// score-thresholds-allow-file: per-tier number colour scale, no API field serves it
import { metricCardContainer as containerClasses } from '../metric-card-styles';

type ScoreColorRange = 'error' | 'warning' | 'high' | 'success';

function getScoreColorRange(score: number): ScoreColorRange {
  if (score < 40) return 'error';
  if (score < 60) return 'warning';
  if (score < 80) return 'high';
  return 'success';
}

// Per-tier number colors (green reserved for 80+). Disabled cells drop the tier
// colour entirely for the shared `text-fg-disabled-subtle` gray.
const scoreColorMap: Record<ScoreColorRange, string> = {
  error: 'text-error-primary',
  warning: 'text-orange-500',
  high: 'text-yellow-500',
  success: 'text-fg-success-secondary',
};

function getScoreColor(colorRange: ScoreColorRange): string {
  return scoreColorMap[colorRange];
}

export { containerClasses, getScoreColor, getScoreColorRange };
export type { ScoreColorRange };
